<template>
<div class="home-background">
  <div class="home-container">
    <h1>Cursor 无限续杯</h1>
    <p>欢迎来到Cursor无限续杯，这里提供最好的服务体验。</p>
    <div class="button-group">
      <button class="btn" @click="getStarted">开始使用</button>
      <button class="btn" @click="pennyLoop">pennyLoop</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Index',
  methods: {
    getStarted() {
      alert("开始使用Cursor无限续杯");
    },
    pennyLoop() {
      window.location.href = "https://cursorbot.top/pennyLoop";
    }
  }
}
</script>

<style scoped>
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.home-background {
  background: linear-gradient(135deg, #e0f7fa, #80deea);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.home-container {
  background: #ffffff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  text-align: center;
  margin: 20px;
}

h1 {
  margin-bottom: 20px;
  font-size: 2.5em;
  color: #333;
}

p {
  font-size: 1.2em;
  color: #666;
  margin-bottom: 30px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn {
  padding: 12px 25px;
  font-size: 1em;
  cursor: pointer;
  border: none;
  border-radius: 25px;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn:hover {
  transform: translateY(-2px);
}

@media (max-width: 600px) {
  .home-container {
    padding: 20px;
  }

  h1 {
    font-size: 2em;
  }

  p {
    font-size: 1em;
  }

  .btn {
    padding: 10px 20px;
    font-size: 0.9em;
  }
}
</style>
